/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExcelExportExtendedModel = {
  readonly id?: number;
  readonly status_label?: string;
  readonly company_name?: string;
  readonly date?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  readonly created_at?: string;
  finished_at?: string | null;
  status?: ExcelExportExtendedModel.status;
  report_type?: ExcelExportExtendedModel.report_type;
  file?: number | null;
  company_measurement_date: number;
};
export namespace ExcelExportExtendedModel {
  export enum status {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
  }
  export enum report_type {
    FULL_COMPANY_REPORT = 'full_company_report',
  }
}
